import React from 'react';
import { Page, Navbar, NavTitle } from 'framework7-react';
import catalog from './catalog.json';

class Artist extends React.Component {
  render = () => {
    return (
      <div
        className="card round"
        onClick={() => this.$f7.views.main.router.navigate('/' + this.props.artist.id, {
          context: {artist: this.props.artist}
        })}
      >
        <div className="image round" style={{backgroundImage: 'url(\'' + this.props.artist.image + '\')'}}></div>
        <h3 className="text">{this.props.artist.name} <small>{this.props.artist.noOfSongs} Songs</small></h3>
      </div>
    )
  }
}

class Catalog extends React.Component {
  render = () => {
    return (
      <Page name="home">
        <Navbar>
          <NavTitle>
            <div className="logo">lyriXpert</div>
          </NavTitle>
        </Navbar>
        <h4>Select your favourite artist!</h4>
        {catalog.artists.map((artist, index) => <Artist artist={artist} key={index} />)}
      </Page>
    )
  }
}

export default Catalog;


// WEBPACK FOOTER //
// ./src/catalog.js